<script>
/**
 * ****************************************************************************
 * @description     :   Main component for page search
 * @created at      :   2024/05/22
 * @created by      :   ANS833 – sondh@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapActions, mapMutations, mapState } from 'vuex';
import store from '@/store';
import CUS_Client003 from '@/views/move/cus_client/CUS_Client003/store';

/**
 * Import template
 */
import template from './template.html';
import './style.scss';
import helpers from '@/utils/helpers';
import messages, { MSG_TYPE, MSG_TITLE } from '@/utils/messages';
import CUS_Client004 from '@/views/move/cus_client/CUS_Client004/index.vue';

/**
 * Define component chat for show page chat
 */
var MasterSearch = {
    template: template,
    components: {
        CUS_Client004
    },
    beforeCreate() {
        if (!store.hasModule('CUS_Client003')) {
            store.registerModule('CUS_Client003', CUS_Client003);
        }
    },
    created() {
        this.setScreenId(this.screenId);
        this.setHeader(this.header);
        // if (!this.$route?.query?.clear) {
        //     this.onInitScreen();
        // } else {
        //     setTimeout(() => {
        //         this.searchItem(this.data);
        //     }, 200);
        // }
    },
    mounted() {
        this.setHeader(this.header);
        window.addEventListener('resize', this.handleResize);
        this.search();
    },
    unmounted() {
        this.setHeader();
        this.hideModalMessage();
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            screenId: 'CUS_Client003',
            validRules: {
                listProcessDayFrom: 'required',
                listProcessDayTo: 'required'
            },
            isShowClient004: false,
            customerCd: null,
            locationCd: null,
            personalId: null,
            row_active: null,
            tooltipWidth: 456,
            sort: {
                location_cd: '',
                location_tel: '',
                location_fax: '',
                contact_name: '',
                contact_tel: '',
                location_address: ''
            }
        };
    },
    computed: {
        ...mapState('CUS_Client003', ['data', 'selectOptionKey', 'totalRows', 'msgNoData', 'listData', 'isSuccess', 'data_select']),
        header() {
            const data = {
                title: '発注拠点一覧',
                // showBack: true,
                onBack: () => {
                    this.$router.push({ name: 'TOP' });
                }
            };
            return data;
        },
        isMobile() {
            return helpers.checkIfMobile();
        }
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'setScreenId', 'setHeader', 'showModalMessage', 'hideModalMessage', 'hideHeaderError']),
        ...mapMutations('CUS_Client003', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        ...mapActions('CUS_Client003', ['searchItem', 'getAreaInfo']),
        search() {
            this.searchItem({
                body: {
                    ...this.data
                },
                callback: (response) => {
                    console.log(response);
                    // blur button search
                    // document.querySelector('#common-search').blur();
                },
                onError: (error) => {
                    this.showModalMessage({
                        type: MSG_TYPE.ERROR,
                        title: MSG_TITLE.S001,
                        content: error.Message,
                        okText: 'OK'
                    });
                }
            });
        },
        closeDetail() {
            this.isShowClient004 = !this.isShowClient004;
            this.row_active = '';
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.search();
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        clearData(data) {
            if (data != '') {
                helpers.removeAllRequireInput();
                this.hideHeaderError();
            }
        },
        submitForm() {
            this.$router.push({ name: 'CUS_Order002' });
        },
        changeArea() {
            if (this.data.area_code == '') {
                this.data.area_name = '';
            } else {
                this.getAreaInfo({
                    body: {
                        company_cd: 1,
                        area_cd: this.data.area_code
                    },
                    callback: (response) => {
                        if (response?.area_name) {
                            this.data.area_name = response?.area_name;
                        } else {
                            this.data.area_name = '';
                        }
                    },
                    onError: (errorMessage) => {
                        this.data.area_code = '';
                        this.data.area_name = '';
                        this.showHeaderError([errorMessage ?? messages.E999]);
                    }
                });
            }
        },
        referClient004(location_cd, personal_id, index) {
            this.isShowClient004 = true;
            this.locationCd = location_cd;
            this.personalId = personal_id;
            this.row_active = index ?? '';
        },
        //referAreaSearch
        referAreaSearch(index, value) {
            console.log('index :>> ', index);
            this.data.area_cd = value;
            if (this.data.area_cd == '') {
                this.data.area_name = '';
            } else {
                this.data.area_name = '東日本統括部';
            }
        },
        getAreaName(data) {
            this.data.area_name = data;
        },
        referUpdate() {
            this.search();
        },
        initArrow(col, key) {
            this.sort = {
                location_cd: '',
                location_tel: '',
                location_fax: '',
                contact_name: '',
                contact_tel: '',
                location_address: ''
            };
            this.sort[col] = key;
        },
        // sortLocationCD(key) {
        //     this.initArrow('location_cd', key);
        //     helpers.sortNull(this.listData, key == 'asc', 'location_cd', false);
        // },
        // sortLocationTEL(key) {
        //     this.initArrow('location_tel', key);
        //     helpers.sortNull(
        //         this.listData,
        //         key == 'asc',
        //         'location_tel',
        //         false
        //     );
        // },
        // sortLocationFAX(key) {
        //     this.initArrow('location_fax', key);
        //     helpers.sortNull(
        //         this.listData,
        //         key == 'asc',
        //         'location_fax',
        //         false
        //     );
        // },
        // sortcontactName(key) {
        //     this.initArrow('contact_name', key);
        //     helpers.sortNull(
        //         this.listData,
        //         key == 'asc',
        //         'contact_name',
        //         false
        //     );
        // },
        // sortContactTEL(key) {
        //     this.initArrow('contact_tel', key);
        //     helpers.sortNull(this.listData, key == 'asc', 'contact_tel', false);
        // },
        // sortLocationAddress(key) {
        //     this.initArrow('location_address', key);
        //     helpers.sortNull(
        //         this.listData,
        //         key == 'asc',
        //         'location_address',
        //         false
        //     );
        // },
        sortCol(key, col) {
            this.initArrow(col, key);
            this.data.sort = key;
            this.data.col = col;
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.search(this.data);
        }
    }
};
export default MasterSearch;
</script>
